import { createContext } from 'react';
import { type DateRange, MASS_TIME_VIEW } from '@/types';

export type MassTimeContextType = {
  selectedWeek: DateRange;
  onWeekChange: (newDateRange: DateRange) => void;
  currentView: MASS_TIME_VIEW;
  setCurrentView: (view: MASS_TIME_VIEW) => void;
};

export const MassTimeContext = createContext<MassTimeContextType | undefined>(undefined);
